import { IntlContext } from 'contexts/IntlContext';
import { useContextStrict } from 'hooks/useContextStrict';

export const useIntlContext = () => {
  return useContextStrict(IntlContext);
};
